import _ from 'lodash';
import uuid from 'uuid';
import moment from 'moment';

import AttachDocuments from '../services/AttachDocuments';
import ImageUtility from './imageUtility';
import { iosCheck } from './stringUtil';
import { DATE_TIME_FORMAT } from '../utilities/constants';
import dialogLoader from '../utilities/dialogLoader';
import { messageUtility } from '../utilities/messageUtility';
import { CancelAndConfirmDialog } from '../components/modals/CancelAndConfirmDialog';

/**
 * 添付書類 情報取得処理 作業員情報
 *  選択項目の小分類コード一覧を取得する
 *  async componentDidMount で呼び出すこと
 */
export const attachDocumentWorkerCodesRead = async (
  state,
  stateNamesCodes = [],
  typeLargeCodes = []
) => {
  if (stateNamesCodes.length !== typeLargeCodes.length) {
    throw new Error('attachDocumentUtil.js attachDocumentWorkerCodesRead');
  }

  const params = {
    offset: 0,
    is_limit: 0,
  };
  await AttachDocuments.documentCodes(params).then(response => {
    if (!response.result) {
      return;
    }
    const { document_codes } = response.data.entities;
    if (!_.isArray(document_codes)) {
      throw new Error('attachDocumentUtil.js attachDocumentWorkerCodesRead');
    }
    stateNamesCodes.forEach((stateName, index) => {
      state[stateName] = document_codes.filter(
        document => document.file_typeL === typeLargeCodes[index]
      );
    });
  });
};

/**
 * 添付書類 ファイルダウンロード処理 会社情報
 */
export const attachDocumentCompanyDownload = async (
  callbackErrorFunc,
  companyId,
  fileId
) => {
  try {
    const file = await AttachDocuments.downloadCompanyDocument(
      companyId,
      fileId
    );
    window.location.href = file;
  } catch (error) {
    const errorMessage = error.toString();
    switch (error.status) {
      // ファイルが存在しない場合エラーメッセージを表示する
      case 404: {
        callbackErrorFunc();
        return false;
      }
      default: {
        console.error(
          'request.js requestWithToken',
          'ネットワークエラーです',
          errorMessage
        );
        window.location.replace('/error-500');
        return false;
      }
    }
  }
};

/**
 * 添付書類 ファイルダウンロード処理 作業員情報
 */
export const attachDocumentWorkerDownload = async (
  callbackErrorFunc,
  companyId,
  workerId,
  fileId
) => {
  try {
    const file = await AttachDocuments.downloadWorkerDocument(
      companyId,
      workerId,
      fileId
    );
    window.location.href = file;
  } catch (error) {
    // console.log(error);
    const errorMessage = error.toString();
    switch (error.status) {
      // ファイルが存在しない場合エラーメッセージを表示する
      case 404: {
        callbackErrorFunc();
        return false;
      }
      default: {
        console.error(
          'request.js requestWithToken',
          'ネットワークエラーです',
          errorMessage
        );
        window.location.replace('/error-500');
        return false;
      }
    }
  }
};

/**
 * 添付書類 ファイル選択処理
 */
export const attachDocumentCompanyUploadState = async (
  stateDocuments,
  setStateDocumentsFunc,
  companyId,
  file,
  typeL,
  typeS
) => {
  let uploadTargetFile = file;
  if (iosCheck() && file.name === 'image.jpg') {
    const newFileName = `image_${moment().format(DATE_TIME_FORMAT.dateTimeSecondFormat)}.jpg`;
    uploadTargetFile = new File([file], newFileName, {
      type: file.type,
    });
  }
  const documentExists = _.some(stateDocuments, ({ file_name, file_typeL, file_typeS }) =>
    file_name === uploadTargetFile.name && file_typeL === typeL && file_typeS === typeS
  );
  const updateDocumentCallback = async () => {
    const validType = await ImageUtility.fileTypeCheckImagePDF(uploadTargetFile);
    const validSize = await ImageUtility.fileSizeCheck(uploadTargetFile, 52428800);
    const validName = await ImageUtility.hasfileName(uploadTargetFile);
    const newDocuments = documentExists
      ? _.filter(stateDocuments, ({ file_name, file_typeL, file_typeS }) =>
          file_name !== uploadTargetFile.name || file_typeL !== typeL || file_typeS !== typeS
        )
      : stateDocuments;
    if (!validType || !validSize || !validName) {
      const documents = _.concat(newDocuments, {
        file_name: uploadTargetFile.name,
        file_typeL: typeL,
        file_typeS: typeS,
        invalidType: !validType,
        invalidSize: !validSize,
        invalidName: !validName,
        temp_file_key: uuid.v4(),
      });
      setStateDocumentsFunc(documents);
    } else {
      AttachDocuments.uploadCompanyDocument(companyId, uploadTargetFile).then(response => {
        if (!response.result) {
          return console.log('Invalid Response:', response);
        }
        const documents = _.concat(newDocuments, {
          file_name: uploadTargetFile.name,
          file_typeL: typeL,
          file_typeS: typeS,
          temp_file_key: response.data.entities.temp_file_key,
        });
        setStateDocumentsFunc(documents);
      });
    }
  };
  if (documentExists) {
    showConfirmOverwriteExistingFile(updateDocumentCallback);
  } else {
    updateDocumentCallback();
  }
};

/**
 * 添付書類 ファイル選択処理
 */
export const attachDocumentWorkerUploadState = async (
  stateDocuments,
  setStateDocumentsFunc,
  companyId,
  workerId,
  file,
  typeL,
  typeS
) => {
  let uploadTargetFile = file;
  if (iosCheck() && file.name === 'image.jpg') {
    const newFileName = `image_${moment().format(DATE_TIME_FORMAT.dateTimeSecondFormat)}.jpg`;
    uploadTargetFile = new File([file], newFileName, {
      type: file.type,
    });
  }
  const documentExists = _.some(stateDocuments, ({ file_name, file_typeL, file_typeS }) =>
    file_name === uploadTargetFile.name && file_typeL === typeL && file_typeS === typeS
  );
  const updateDocumentCallback = async () => {
    const validType = await ImageUtility.fileTypeCheckImagePDF(uploadTargetFile);
    const validSize = await ImageUtility.fileSizeCheck(uploadTargetFile, 52428800);
    const validName = await ImageUtility.hasfileName(uploadTargetFile);
    const newDocuments = documentExists
      ? _.filter(stateDocuments, ({ file_name, file_typeL, file_typeS }) =>
          file_name !== uploadTargetFile.name || file_typeL !== typeL || file_typeS !== typeS
        )
      : stateDocuments;
    if (!validType || !validSize || !validName) {
      const documents = _.concat(newDocuments, {
        file_name: uploadTargetFile.name,
        file_typeL: typeL,
        file_typeS: typeS,
        invalidType: !validType,
        invalidSize: !validSize,
        invalidName: !validName,
        temp_file_key: uuid.v4(),
      });
      setStateDocumentsFunc(documents);
    } else {
      AttachDocuments.uploadWorkerDocument(companyId, workerId, uploadTargetFile).then(
        response => {
          if (!response.result) {
            return console.log('Invalid Response:', response);
          }
          const documents = _.concat(newDocuments, {
            file_name: uploadTargetFile.name,
            file_typeL: typeL,
            file_typeS: typeS,
            temp_file_key: response.data.entities.temp_file_key,
          });
          setStateDocumentsFunc(documents);
        }
      );
    }
  }
  if (documentExists) {
    showConfirmOverwriteExistingFile(updateDocumentCallback);
  } else {
    updateDocumentCallback();
  }
};

/**
 * 添付書類 ファイル登録削除処理
 */
export const attachDocumentDeleteState = (
  stateDocuments,
  setStateDocumentsFunc,
  file
) => {
  const documents = _.filter(stateDocuments, document => {
    return !_.isEqual(document, file);
  });

  setStateDocumentsFunc(documents);
};

/**
 * 添付ファイルのサイズ・タイプ・ファイル名が存在するかチェック
 */
export const attachDocumentFilesCheck = stateDocuments => {
  return _.some(stateDocuments, 'invalidSize')
    ? false
    : _.some(stateDocuments, 'invalidType')
    ? false
    : _.some(stateDocuments, 'invalidName')
    ? false
    : true;
};

const showConfirmOverwriteExistingFile = (confirmAction) => {
  dialogLoader.show(CancelAndConfirmDialog, {
    title: messageUtility.getMessage('E-000-005-01'),
    message: messageUtility.getMessage('W-000-020'),
    confirmButtonText: messageUtility.getMessage('I-000-088'),
    isNegative: false,
    onCancel: () => {
      dialogLoader.close();
    },
    onConfirm: () => {
      confirmAction();
      dialogLoader.close();
    },
    multilineText: true,
  });
};



// WEBPACK FOOTER //
// ./src/utilities/attachDocumentUtil.js